module.exports = __webpack_public_path__ + "img/cos-rule-bg.6a92a644.png";